import YAML from 'json-to-pretty-yaml';
import { DashboardJson } from '../modules/models';
import { Formatter } from '../modules/components';

export const transformDashboard = (dashboard: DashboardJson, formatter: Formatter) =>
  formatter === Formatter.YAML ? YAML.stringify(dashboard) : JSON.stringify(dashboard, null, 2);
